import classNames from "classnames";
import DotsOptionsMenu from "components/Menus/DotsOptionsMenu";
import React from "react";

const ItemWithOptions = ({ name, options, onOpen, onClose, border }) => {
  return (
    <div
      className={classNames(
        "d-flex align-items-center justify-content-between p-2",
        { "border-bottom border-superlight": border }
      )}
    >
      {name}
      <DotsOptionsMenu
        options={options}
        onOpen={onOpen}
        onClose={onClose}
        dotsSize={20}
      />
    </div>
  );
};

export default ItemWithOptions;
